import Vue from 'vue'
import VueRouter from 'vue-router'
import store     from '@/store/index.js'
import routes    from "@/router/routes";

Vue.use(VueRouter)

const unicodeToBase64 = function (str) {
	// Encode the string to UTF-8 bytes
	const utf8Bytes = new TextEncoder().encode(str);
	// Convert the byte array to a binary string
	const binaryString = String.fromCharCode(...utf8Bytes);
	// Encode the binary string to Base64
	return btoa(binaryString);
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach( ( to, from, next ) => {

	//AUTHENTICATION GUARD
	if( to.meta.auth.required && !store.getters.isSignedIn ) {
		sessionStorage.setItem('pre-auth-request-url', to.fullPath)
		next( '/auth/sign-in?redirect=' + unicodeToBase64(to.fullPath) );
	}
	else {
		next();
	}
} );

export default router
